<template><div><h1 id="systemparameter" tabindex="-1"><a class="header-anchor" href="#systemparameter"><span>Systemparameter</span></a></h1>
<p>Systemparameter — Konfigurations- und Laufzeitparameter</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Über Systemparameter werden zentrale Einstellungen in funtrade parametrisiert. Im folgenden sind alle Systemparameter in einer Tabelle aufgeführt, in der die möglichen Werte und deren Bedeutung kurz aufgelistet sind.</p>
<p>Die Systemparameter können und dürfen nur durch Arenae geändert werden.</p>
<p><strong>Tabelle 59. Systemparameter</strong></p>
<table>
<thead>
<tr>
<th>Parameter</th>
<th>Beschreibung</th>
<th>Wert (Beispiel)</th>
</tr>
</thead>
<tbody>
<tr>
<td>EPnichtIVorschlag</td>
<td>Sammelerfassung Ereignisse: Ereignisposition aus Initial nicht vorgeschlagen</td>
<td></td>
</tr>
<tr>
<td>Korresp_Kanal</td>
<td>Korrespondenz erfassen: default Kanal</td>
<td>Post</td>
</tr>
<tr>
<td>ProjRollen</td>
<td>ProjektRollen (Semikolon getrennt Verantwortliche Marketing und Verantwortliche Programm)</td>
<td>verantw. Marketing;verantw. Programm</td>
</tr>
<tr>
<td>MD_Zweck_Projekt</td>
<td>Nachlass Projekt für Aktion Verfügung (nicht zweckgebunden ist)</td>
<td>Freie Mittel</td>
</tr>
<tr>
<td>MD_Todesdatum</td>
<td>Nachlass Todesdatum Merkmal-Mapping</td>
<td>3</td>
</tr>
<tr>
<td>Vermittler</td>
<td>Nachlass: Rolle für Vermittler</td>
<td>Vermittler(in)</td>
</tr>
<tr>
<td>Willensvollstrecker</td>
<td>Nachlass: Rolle für Willensvollstrecker</td>
<td>Willensvollstrecker(in)</td>
</tr>
<tr>
<td>Zustandiger</td>
<td>Nachlass: Rolle für Zuständige</td>
<td>Zuständige(r)</td>
</tr>
<tr>
<td>Erblasser</td>
<td>Nachlass: Rolle für Erblasser</td>
<td>Erblasser(in)</td>
</tr>
<tr>
<td>ErfEreignisBeiRolle</td>
<td>Automatische Erfassung von Ereignissen bei Übernahme einer Rolle</td>
<td>true</td>
</tr>
<tr>
<td>aaee</td>
<td>Ereignisse für Adresse aktivieren / deaktivieren (sperren) (Format ohne Abstand: AktivEreig,AktivErpnr,AktivTyp, AktivKat# SperrEreig,SperrErpnr,SperrTyp, SperrKat)</td>
<td>51,1,A,</td>
</tr>
<tr>
<td>AdrAbteilungZusatz</td>
<td>Adress-Abteilung Merkmal-Mapping</td>
<td>Abteilung</td>
</tr>
<tr>
<td>AdrFunktionZusatz</td>
<td>Adress-Funktion Merkmal-Mapping</td>
<td>Funktion</td>
</tr>
<tr>
<td>AdrBrancheZusatz</td>
<td>Adress-Branche Merkmal-Mapping</td>
<td>Branche</td>
</tr>
<tr>
<td>AdrBerufZusatz</td>
<td>Adress-Beruf Merkmal-Mapping</td>
<td>Beruf</td>
</tr>
<tr>
<td>AdrHerkunftZusatz</td>
<td>Adressherkunft Merkmal-Mapping</td>
<td>Herkunft</td>
</tr>
<tr>
<td>AdrEreigBez</td>
<td>Adress / Ereignissbezeichnung anzeigen</td>
<td>{terkopf.ereigid}: {terpos.ereigbez}</td>
</tr>
<tr>
<td>AdrFunktion</td>
<td>Adress-Funktion anzeigen</td>
<td>ja</td>
</tr>
<tr>
<td>AdrUpdateBedingung</td>
<td>Adress-Update Felder Bedingungen</td>
<td></td>
</tr>
<tr>
<td>adts</td>
<td>Temporäre Sperre bei den Adressen</td>
<td>50,0,XE</td>
</tr>
<tr>
<td>aizu</td>
<td>Umsatz in Auftragsinfozeile der letzten x Jahre</td>
<td>3</td>
</tr>
<tr>
<td>anredeDNR</td>
<td>Regelsystem Doppelnamen (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>adressWarnSperr</td>
<td>Personenmerkmale, Warnung/Sperre bei Verkauf (MerkmalId;Wirkung;Bereich:..)</td>
<td></td>
</tr>
<tr>
<td>artikelGruppen</td>
<td>Liste Artikelgruppen Parentmerkmale (MerkmalId Kommagetrennt)</td>
<td></td>
</tr>
<tr>
<td>artikelWarnSperr</td>
<td>Artikelmerkmale, Warnung/Sperre bei Verkauf (MerkmalId;Wirkung:..)</td>
<td></td>
</tr>
<tr>
<td>asdc</td>
<td>Anlassspende - Default Dokumentencode</td>
<td></td>
</tr>
<tr>
<td>asep</td>
<td>Artikelseparator (trennt Haupt und Zusatzteil)</td>
<td>.</td>
</tr>
<tr>
<td>asva</td>
<td>Anlass-Verdankungsart (Anlass/Steuertabelle)</td>
<td>Anlass</td>
</tr>
<tr>
<td>aufErfSperre</td>
<td>Auftragserfassung, Sperrmerkmale (Liste der eigensid Nummer)</td>
<td></td>
</tr>
<tr>
<td>aufErfWarn</td>
<td>Auftragserfassung, Warnmerkmale (Liste der eigensid Nummern)</td>
<td></td>
</tr>
<tr>
<td>aufh</td>
<td>Aufträge älter als x Tage in alte Aufträge verschieben</td>
<td>365</td>
</tr>
<tr>
<td>aufn</td>
<td>Erste freie Auftragsnummer</td>
<td>1000000</td>
</tr>
<tr>
<td>authType</td>
<td>Login Authentifizierung (Classe1:Par1:...,Classe2) (gibt nur OK/NOK zurück)</td>
<td>ch.arenae.dnp.AuthenticateInApp</td>
</tr>
<tr>
<td>auve</td>
<td>Aufträge - Vorauszahlunsgänderung möglich</td>
<td>true</td>
</tr>
<tr>
<td>auvk</td>
<td>Aufträge aufbereiten, Verarbeitungsarten</td>
<td>R,V,P,S,X</td>
</tr>
<tr>
<td>azlm</td>
<td>Adresse zum Löschen markieren (Ereignisnummer, Typ, Kat)</td>
<td>56,X,L</td>
</tr>
<tr>
<td>AvisZusage</td>
<td>Avisierung bei Neu-Fakturierung einer bestehenden Zusage (Dokumentensatz,Ausgabeformat)</td>
<td></td>
</tr>
<tr>
<td>bere</td>
<td>Adressbereinigung, Ereignisverkn. (State,Ereig,Pos)</td>
<td>I?,55,5</td>
</tr>
<tr>
<td>berr</td>
<td>Adressbereinigung, Adressreakt. (Datentyp;Refusécode)</td>
<td>P;XX,XU</td>
</tr>
<tr>
<td>bezirkGruppe</td>
<td>Regionengruppen: Bezirkgruppe</td>
<td></td>
</tr>
<tr>
<td>BirtOrg</td>
<td>Ausgeschriebener Name der Organisation, wird in manchen Listen gezeigt</td>
<td></td>
</tr>
<tr>
<td>bstr</td>
<td>Botschafter</td>
<td>Format: Projekttyp,Aktion,Anzahl</td>
</tr>
<tr>
<td>bsdt</td>
<td>Buchunssperre Datum</td>
<td>31.12.2001,svw</td>
</tr>
<tr>
<td>bsld</td>
<td>Bereitstellungsliste drucken</td>
<td>SORT-ARTIKEL,TEILEN</td>
</tr>
<tr>
<td>crai</td>
<td>Corris Import Adressen, Format ohne Abstand: Quelle#KTypTel1,KTypTel2, KTypTel3#KtypEmail#OE</td>
<td></td>
</tr>
<tr>
<td>corrisEsrAustritt</td>
<td>Import Corris: Gleichartige Zusagen nicht LSV/BAD überschreiben</td>
<td></td>
</tr>
<tr>
<td>corrisZahlung</td>
<td>Corris Import Zahlungsdatei: abDatum#Zahlungskonto# ZMod1,ZArt1,ZMod2,ZArt2</td>
<td>#</td>
</tr>
<tr>
<td>crbd</td>
<td>Corris Datenexport für Bonusberechnung</td>
<td></td>
</tr>
<tr>
<td>crua</td>
<td>Corris Import - unvollständige Adresse</td>
<td></td>
</tr>
<tr>
<td>deba</td>
<td>Buchungen aggregieren - Schnittstellen-Parameter</td>
<td>NAVISION, /u/out/pub/nav/NF00&amp;1.TXT,iso8859-1</td>
</tr>
<tr>
<td>debi</td>
<td>Virtueller Debitor (falls unbekannte Zahlung)</td>
<td>999999</td>
</tr>
<tr>
<td>CorrisImpVariante</td>
<td>Corris Importvariante</td>
<td>total</td>
</tr>
<tr>
<td>dfex</td>
<td>Ereignisvorschlag bei Zusagezahlung</td>
<td>9860</td>
</tr>
<tr>
<td>dfez</td>
<td>Ereignisvorschlag bei Spendenzahlung</td>
<td>9405</td>
</tr>
<tr>
<td>disconnectUser</td>
<td>OpenEdge OS-Command zum User disconnect (definiert mit Nummer)</td>
<td><code v-pre>&lt;DLC&gt;/bin/proshut &lt;APP&gt;/db/&lt;DBAPP&gt; -C disconnect </code></td>
</tr>
<tr>
<td>ehis</td>
<td>Ereignis-History</td>
<td>Haushalt:yes,Fremd:yes,AnzJ:0</td>
</tr>
<tr>
<td>E-Mail-0-content</td>
<td>E-Mail Message Body</td>
<td>Siehe Beispiel unten</td>
</tr>
<tr>
<td>E-Mail-1-title</td>
<td>E-Mail Message Title</td>
<td></td>
</tr>
<tr>
<td>E-Mail-3-row-title</td>
<td>E-Mail Message Row-Title</td>
<td><code v-pre>&lt;p style=&quot;font-family: sans-serif; font-size: 14px; font-weight: bold; margin: 0; Margin-bottom: 5px; background-color: #f6f6f6;&quot;&gt;&lt;!--INSERT-CONTENT--&gt;&lt;/p&gt;</code></td>
</tr>
<tr>
<td>E-Mail-3-row-txt</td>
<td>E-Mail Message Row-Text</td>
<td><code v-pre>&lt;p style=&quot;font-family: sans-serif; font-size: 14px; font-weight: normal; margin: 0; Margin-bottom: 15px;&quot;&gt;&lt;!--INSERT-CONTENT--&gt;&lt;/p&gt;</code></td>
</tr>
<tr>
<td>E-Mail-row-footer</td>
<td>E-Mail Message Footer</td>
<td><code v-pre>&lt;!--INSERT-CONTENT-BEFORE--&gt; &lt;p&gt; Diese Nachricht wurde automatisch in funtrade ausgel&amp;ouml;st. &lt;img width=&quot;16&quot; height=&quot;16&quot; style=&quot;max-width:100%; width:1.5em; height:1.5em; opacity: 0.8;&quot; src=&quot;https://ops.arenae.ch/images/funtrade-64.png&quot; alt=&quot;funtrade&quot; /&gt; &lt;/p&gt; &lt;!--INSERT-CONTENT-AFTER--&gt; </code></td>
</tr>
<tr>
<td>einzelVerdankung</td>
<td>Einzelanrede bei Verdankungen</td>
<td>false</td>
</tr>
<tr>
<td>EreigTreeExpand</td>
<td>Ereignisansicht im Tree soll als default aufgemacht werden (true)</td>
<td></td>
</tr>
<tr>
<td>etikettPubl</td>
<td>Publikationen auf Etiketten (Kommagetrennt)</td>
<td></td>
</tr>
<tr>
<td>expandMultiVornam</td>
<td>Ersetzt mehrere Vornamen Sprachahängig A &amp; B zu A und B (true)</td>
<td></td>
</tr>
<tr>
<td>fakn</td>
<td>Erste freie Fakturanummer</td>
<td>2000000</td>
</tr>
<tr>
<td>fwav</td>
<td>FunTrade Web - Adressvalidierung</td>
<td>false</td>
</tr>
<tr>
<td>fwwp</td>
<td>FunTrade Web - WV Parameter</td>
<td>0,</td>
</tr>
<tr>
<td>goto</td>
<td>Gehezu um die Suchfelder erweitern (active/passive)</td>
<td>passive</td>
</tr>
<tr>
<td>hagj</td>
<td>Haus-Geschäftsjahr fängt am Monat</td>
<td>7</td>
</tr>
<tr>
<td>hama</td>
<td>Hausadresse (Adresse der eigenen Organisation)</td>
<td>5689</td>
</tr>
<tr>
<td>hhTelekomTypen</td>
<td>Haushalte - gemeinsame Adresstypen</td>
<td>TEL,FAX</td>
</tr>
<tr>
<td>hhaa</td>
<td>Haushaltsanreden - Alter für Kinder (gilt bis Alter)</td>
<td>17</td>
</tr>
<tr>
<td>hhzc</td>
<td>Haushalte - Zuordnungscode</td>
<td>hh</td>
</tr>
<tr>
<td>initAnmeldeStat</td>
<td>Veranstaltung - initial Anmelde-Status nach Anzeige-Typ (Standard:Anmelde-Status, Event:Anmelde-Status)</td>
<td>Standart:P,Event:P</td>
</tr>
<tr>
<td>InternetAuswertungZusArten</td>
<td>Internetauswertung - Zusage Arten</td>
<td></td>
</tr>
<tr>
<td>jrab</td>
<td>Erste freie Belegnummer für aggregierte Buchungen</td>
<td>10000</td>
</tr>
<tr>
<td>JugendLag</td>
<td>Jugendlager(Veranstaltungstyp)</td>
<td></td>
</tr>
<tr>
<td>kasa</td>
<td>Kassenverkauf</td>
<td>VOCD,KVZ,ADR,19000, LART,N,BART,KV,EIAUF,IMP</td>
</tr>
<tr>
<td>WSSofortKorrespondenz</td>
<td>WS: Korrespondenz soffort aufbereiten (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>WSSofortVerdank</td>
<td>WS: Verdankungen soffort aufbereiten (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>WSSofortWBSFakt</td>
<td>WS: WBS soffort fakturieren (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>ZahlungOEEintrag</td>
<td>Automatischer Eintrag OE bei Zahlungseingang</td>
<td>nein</td>
</tr>
<tr>
<td>kampaWeb</td>
<td>KampaWEB aktive (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>kinf</td>
<td>Konfigurierbarer Bereich (vormals Info-Frame bzw. Kundenspezifischer Bereich)</td>
<td></td>
</tr>
<tr>
<td>kontaktEreignis</td>
<td>Kontakt Ereignis erfassen (EreigNr,ErpNr,Typ,Kat,Kanal)</td>
<td></td>
</tr>
<tr>
<td>kspw</td>
<td>Kassenpasswort</td>
<td>(hier Passwort verschlüselt)</td>
</tr>
<tr>
<td>ldri</td>
<td>LSV/DD Rückbuchungen importieren - ZeitInterval</td>
<td>30</td>
</tr>
<tr>
<td>limitReduziertBuch</td>
<td>letzte Buchungen zu Adresse (Limit = Zahl)</td>
<td>300</td>
</tr>
<tr>
<td>LsvDdGrenztag</td>
<td>Standard-&quot;Zeitabstände&quot; für nächste Fakturierung LSV/DD</td>
<td></td>
</tr>
<tr>
<td>maen</td>
<td>Ereignis für eine Mahnung</td>
<td>800</td>
</tr>
<tr>
<td>main</td>
<td>Mahnungsintervall (default) (in Tage)</td>
<td>45</td>
</tr>
<tr>
<td>mati</td>
<td>Zusagenmarkierungen aufheben Interval</td>
<td>60</td>
</tr>
<tr>
<td>more</td>
<td>Merkmal für Monatsrechnungen</td>
<td></td>
</tr>
<tr>
<td>npro</td>
<td>Non-Profit Organisation</td>
<td>KurznameDerOrganisation</td>
</tr>
<tr>
<td>NavigatorConfig</td>
<td>Navigator Configuration XML Datei</td>
<td><code v-pre>&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; ?&gt; &lt;NavigatorConfiguration&gt; &lt;categories&gt; &lt;category color=&quot;(55,160,170)&quot; id=&quot;CAT_ADR&quot; name=&quot;Personen&quot;/&gt; &lt;category color=&quot;(30,120,155)&quot; id=&quot;CAT_PROJ&quot; module=&quot;CAT_PROJ&quot; name=&quot;Projektfinanzierung&quot;/&gt; &lt;category color=&quot;(0,90,130)&quot; id=&quot;CAT_ORDER&quot; module=&quot;CAT_ORDER&quot; name=&quot;Verkauf&quot;/&gt; &lt;category color=&quot;(160,195,105)&quot; id=&quot;CAT_ART&quot; module=&quot;CAT_ART&quot; name=&quot;Logistik&quot;/&gt; &lt;category color=&quot;(85,120,40)&quot; id=&quot;CAT_EVENT&quot; module=&quot;CAT_EVENT&quot; name=&quot;Veranstaltungen&quot;/&gt; &lt;category color=&quot;(235,165,60)&quot; id=&quot;CAT_NACHLASS&quot; module=&quot;CAT_NACHLASS&quot; name=&quot;Nachlass&quot;/&gt; &lt;category color=&quot;(215,130,10)&quot; id=&quot;CAT_ACCT&quot; name=&quot;Buchhaltung&quot;/&gt; &lt;category color=&quot;(185,095,000)&quot; id=&quot;CAT_EXTRAS&quot; name=&quot;Datenaustausch&quot;/&gt; &lt;category color=&quot;(190,40,60)&quot; id=&quot;CAT_SYS&quot; name=&quot;Systemverwaltung&quot;/&gt; &lt;/categories&gt; &lt;/NavigatorConfiguration&gt;</code></td>
</tr>
<tr>
<td>oerg</td>
<td>Org. Einheiten - Regionengruppe</td>
<td></td>
</tr>
<tr>
<td>outputPathRestrict</td>
<td>Verzeichnis für Outputs auf timerBase einschränken (true/false)</td>
<td>true</td>
</tr>
<tr>
<td>pgvl</td>
<td>Projektgruppe vertteil. Länge</td>
<td>3</td>
</tr>
<tr>
<td>ppBemerk</td>
<td>Projektpartner-Bemerkung</td>
<td></td>
</tr>
<tr>
<td>ppla</td>
<td>Projektpartnerliste - Aktion-Parameters</td>
<td>gesu;verd,absa,abge</td>
</tr>
<tr>
<td>prof</td>
<td>Adressprofil aus den letzten X Jahren bilden</td>
<td>3</td>
</tr>
<tr>
<td>projektumsatzBerechnung</td>
<td>Regeln für Berechnung Projektumsatz nach Jahren (Format ohne Abstand: Jahrkontrolle; InitAktion)</td>
<td>nein;gesu</td>
</tr>
<tr>
<td>pspa</td>
<td>Profilsperre ZSK für Merkmale:</td>
<td>UNZU</td>
</tr>
<tr>
<td>pspk</td>
<td>Profilsperre Käufer für Merkmale:</td>
<td>xxxx</td>
</tr>
<tr>
<td>pswd</td>
<td>Passwortparameter: Länge=n,GrossKleinZahlZwingend=true</td>
<td>5,false</td>
</tr>
<tr>
<td>psps</td>
<td>Profilsperre Spender für Merkmale:</td>
<td>xxxx</td>
</tr>
<tr>
<td>ptad</td>
<td>Verzeichnis (Pfad) für intern generierte Produktionsdaten</td>
<td><code v-pre>&lt;APP&gt;/tm/sys</code></td>
</tr>
<tr>
<td>publ</td>
<td>Publikationen</td>
<td>anzahl</td>
</tr>
<tr>
<td>remi</td>
<td>Ex-Zusager bis zu x Tagen reaktivieren</td>
<td>365</td>
</tr>
<tr>
<td>rfm</td>
<td>RFM</td>
<td>f-achse,0,a-achse,0</td>
</tr>
<tr>
<td>roiadr</td>
<td>Adressumsatz - ROI berechnen</td>
<td></td>
</tr>
<tr>
<td>rlag</td>
<td>Standard-Retourlager,Partientyp</td>
<td>18000,R,VV;*D</td>
</tr>
<tr>
<td>slza</td>
<td>Merkmal für Schlechtzahler (Verkaufsbezogen)</td>
<td></td>
</tr>
<tr>
<td>SperreBeziehungBeenden</td>
<td>Bei Sperre der Kategorie Beziehungen beenden (Kategorie1,Kategorie2,...)</td>
<td></td>
</tr>
<tr>
<td>timeoutProcall</td>
<td>Wartezeit in Sekunden bei bestimmten Anfragen (Adressuche)</td>
<td>15</td>
</tr>
<tr>
<td>timerRunJob</td>
<td>Programmname mit Pfad für Jobstart im Timer</td>
<td>timerRunJob</td>
</tr>
<tr>
<td>tkom</td>
<td>Telefonbucheinträge unter Telekommunikation anzeigen (aktiv / passiv)</td>
<td>aktiv</td>
</tr>
<tr>
<td>uafd</td>
<td>Personenumsatz-Typ für Freiwllige Debi-Note</td>
<td>fde</td>
</tr>
<tr>
<td>uawh</td>
<td>Personenumsatz-Typ für Kauf</td>
<td>wah</td>
</tr>
<tr>
<td>ukde</td>
<td>Urkunde</td>
<td>Format: Projekttyp,Aktion,Anzahl</td>
</tr>
<tr>
<td>umba</td>
<td>Artikel Umbuchen-Versandart./Order. ausschliessen</td>
<td></td>
</tr>
<tr>
<td>umbv</td>
<td>Artikel Umbuchen - Versandarten/Order vorziehen</td>
<td>1,P,S</td>
</tr>
<tr>
<td>umex</td>
<td>Umsatz für Exp. MB-FAKT/WORD-EXP1 (UMSAJS, UMSVJS)</td>
<td>mit</td>
</tr>
<tr>
<td>upRunnerFirstDir</td>
<td>upRunner - der ersten beruecksichtigen Pfad</td>
<td></td>
</tr>
<tr>
<td>veranstZusatz</td>
<td>Veranstaltung Merkmal-Mapping (Preis2,Maedchen, Jungen,Sprache,WEB)</td>
<td>,,,,</td>
</tr>
<tr>
<td>veranstEreig</td>
<td>Ereignisse und Typen (Ereignis:Typ) für Veranstaltung: (Format ohne Abstand: Anmeldung,Teilnahme, Storno ohne Gebühr,Storno mit Gebühr, Informierung, Einladung, Einladung zusagen,Einladung absagen, Bestätigung, Teilnahme storniert, keine Teilnahme, Annullierung, Informierung (Warteliste),keine Rückmeldung,Warteliste</td>
<td></td>
</tr>
<tr>
<td>veranstAbgelehnt</td>
<td>Stornogrund in Veranstaltung für abgelehnt</td>
<td></td>
</tr>
<tr>
<td>vkef</td>
<td>Verdankungen Export-Format</td>
<td>VERDANK</td>
</tr>
<tr>
<td>vkgw</td>
<td>Versandkosten nach Gewicht (Grund+Wert/Kg)</td>
<td>5.3+0.8</td>
</tr>
<tr>
<td>wpar</td>
<td>FTML-Import-Parameter - Personenquelle für neue von FTML erfasste Adressen</td>
<td>FTML</td>
</tr>
<tr>
<td>wpcc</td>
<td>FTML: Zuordnung bei PaymentType=CreditCard, CardName, Syntax:CN,...CN;Konto#...</td>
<td>Visa,Das gelbe Konto;1902#MasterCard;1910</td>
</tr>
<tr>
<td>zusAustrittEreig</td>
<td>Adressabgleich: Austrittsereignisse für einzelne Zusagen in der Form 'Zusage,Austritt-Ereignis,Ereignis-Position,Kanal'</td>
<td></td>
</tr>
<tr>
<td>wpex</td>
<td>FTML: Zuordnung bei PaymentType=External, PaymenData(PD),PD,... PD;KK-ID#... zum Beispiel: &quot;Mastercard;1#*;5&quot; - wenn bei PaymentType=External bei PaymentData das Wort &quot;Mastercard&quot; vorkommt, wird mit der Kreditkarte Nummer 1 gebucht, sonst Karte Nr. 5.</td>
<td>Visa,Das gelbe Konto;3#MasterCard;7</td>
</tr>
<tr>
<td>wrzi</td>
<td>WBS Rückgangig machen - Zeit-Interval</td>
<td>7</td>
</tr>
<tr>
<td>wsco</td>
<td>WSGetConcerns: Merkmalgruppen für Interessensgebiete</td>
<td></td>
</tr>
<tr>
<td>wslg</td>
<td>WS Web Login</td>
<td>901,1,I,,Web</td>
</tr>
<tr>
<td>wsam</td>
<td>WS Web Adressmutation</td>
<td>902,1,I,,Web</td>
</tr>
<tr>
<td>wskr</td>
<td>WS Verkaufs-Rabattcode</td>
<td>60</td>
</tr>
<tr>
<td>WSKonkretFakturaDoc</td>
<td>WS: Dokumentensatz für 'Konkret' (bezahlt mit Rechnung)</td>
<td></td>
</tr>
<tr>
<td>WSKonkretKKDoc</td>
<td>WS: Dokumentensatz für 'Konkret' (bezahlt mit KreditKarte)</td>
<td></td>
</tr>
<tr>
<td>WSShopDoc</td>
<td>WS: Dokumentensatz für 'Shop'</td>
<td></td>
</tr>
<tr>
<td>WSP2PAnlassBetreuer</td>
<td>WS: P2P Services, Anlassspende Betreuer (ein funtrade Benutzer-Kürzel). funtrade setzt dieses Benutzer-Kürzel im Feld Betreuer auf dem Anlass ein.</td>
<td></td>
</tr>
<tr>
<td>zusageFaktAusschluss</td>
<td>Ausschluss aus Zusagefakturierung, (Zusageart,Typ;...)</td>
<td></td>
</tr>
<tr>
<td>uniqEmailPubs</td>
<td>Unique E-Mail Publikation</td>
<td>nein</td>
</tr>
<tr>
<td>PostDatAkt</td>
<td>URL für Aktualisierung Postdaten</td>
<td>http://support.arenae.ch/post/MATCH-latest.csv</td>
</tr>
<tr>
<td>kanalForFtmlQuelle</td>
<td>FTML Parametrisierung: Kanal zu Quelle Format: quelle1,kanal1#quelle2,kanal2#...</td>
<td></td>
</tr>
<tr>
<td>DubZusEreignis</td>
<td>Ereignis bei Dublettenzuammenführung (Ereignis, Ereignisposition, Ereignistyp, Ereigniskategorie, Kanal)</td>
<td></td>
</tr>
<tr>
<td>akquiMerkmalDD</td>
<td>Ereignismerkmal-ID für Direct Dialog Akquisition</td>
<td></td>
</tr>
<tr>
<td>austrittKanalTyp</td>
<td>Kanal, Typ und Kategorie für Austrittsereignis(Kanal,Typ,Kategorie)</td>
<td>Post,R,</td>
</tr>
<tr>
<td>VansOrtMerkmalID</td>
<td>Merkmal-ID für Veranstaltungsort</td>
<td></td>
</tr>
<tr>
<td>MajorDonor</td>
<td>Major Donor Parameters (FondsMFKst;Aktion;AktionState)</td>
<td>;;;</td>
</tr>
<tr>
<td>P2PEreigbez</td>
<td>P2P Campaign Ereignissbezeichnung, z.B. {datum}<em>{adrnum}</em> {vorname}<em>{nachname}</em> {email}_{merkmale}</td>
<td></td>
</tr>
<tr>
<td>ftmlP2PEreig</td>
<td>P2P Campaign: Ereignissparameter bei Kontakt (Typ,Kat,Kanal). Falls der Parameter gesetzt ist, erzeugt funtrade eine Ereignisverknüpfung mit der Kontaktperson beim Erstellen einer P2PCampaign.</td>
<td></td>
</tr>
<tr>
<td>projgrpMerkmalId</td>
<td>Projekt-Gruppe Merkmal-Mapping</td>
<td></td>
</tr>
<tr>
<td>projkbezMerkmalId</td>
<td>Projekt-Kurzbezeichnung Merkmal-Mapping</td>
<td></td>
</tr>
<tr>
<td>RaiseNowEmail</td>
<td>Email aus RaiseNow; Format: EmailTyp1,Ereig1,Erpnr1,Typ1,Kat1; EmailTyp2,Ereig2,Erpnr2,Typ2,Kat2</td>
<td></td>
</tr>
<tr>
<td>RaiseNowZusage-Einzug-Erster</td>
<td>Zusage aus RaiseNow - erster Einzug; Format: ZusArt1,ZusTyp1,Ereig1,Erpnr1; ZusArt2,ZusTyp2,Ereig2,Erpnr2</td>
<td></td>
</tr>
<tr>
<td>RaiseNowZusage-Einzug-Erfolgreich</td>
<td>Zusage aus RaiseNow - erfolgreich Einzug; Format: ZusArt1,ZusTyp1,Ereig1,Erpnr1; ZusArt2,ZusTyp2,Ereig2,Erpnr2</td>
<td></td>
</tr>
<tr>
<td>RaiseNowZusage-Einzug-Fehlerhaft</td>
<td>Zusage aus RaiseNow - fehlerhaft Einzug; Format: ZusArt1,ZusTyp1,Ereig1, Erpnr1,Typ1,Kat1; ZusArt2,ZusTyp2,Ereig2, Erpnr2,Typ2,Kat2</td>
<td></td>
</tr>
<tr>
<td>MailServlet</td>
<td>Sent Email durch APP Server (Host;Port)</td>
<td></td>
</tr>
<tr>
<td>FeedbackAktion</td>
<td>Aktion für Feedbackmanagement</td>
<td></td>
</tr>
<tr>
<td>BounceEKomm</td>
<td>Bounce EKommunikation; Format: TagesIntervall#Hard-Bounce Ereignum,Erpnr,Typ,Kat#Soft-Bounce Limit# Soft-Bounce Stunden-Zeitintervall# Soft-Bounce Ereignum,Erpnr,Typ,Kat</td>
<td>10#?,?,X,U#3#48#?,?,X,U</td>
</tr>
<tr>
<td>WbsFaktSort</td>
<td>WBS Aufbereiten - Sortierung bei Fakturierung</td>
<td></td>
</tr>
<tr>
<td>terkopfProjakt</td>
<td>Aktion für Individualmarketing; Format: Aktion,Status</td>
<td></td>
</tr>
<tr>
<td>debiKontoMap</td>
<td>Zuordnung Debitorenkontos für Verkauf, Corporate, Veranstaltungen, Grossgönner, Vermittler/Anonyme, Stiftungen, öffentliche Institutionen, Nachlass, übrige</td>
<td></td>
</tr>
<tr>
<td>MD-NachlassErfEreignis</td>
<td>Nachlass-Ereignis (Ereignisnummer,Positionnummer, Typ,Kategorie)</td>
<td></td>
</tr>
<tr>
<td>quelle-person-manuell</td>
<td>Quelle bei manuell erfasste Person</td>
<td>m</td>
</tr>
<tr>
<td>XGAktivierenNachTage</td>
<td>Adressabgleich: XG-Sperre aktivieren nach Tagen (Anzahl Tagen) (leer = Sperre nicht aktivieren)</td>
<td></td>
</tr>
<tr>
<td>AustritAkquiBeschenkteEreig</td>
<td>Austrittsereignisse und Akquisitionsereignisse von Beschenkten bei Drittzahler zeigen</td>
<td>false</td>
</tr>
<tr>
<td>ArtikelTPZusatz</td>
<td>Transitorisches Passiv Artikel - Merkmal-Mapping</td>
<td></td>
</tr>
<tr>
<td>MD-BuchungEreigKnot</td>
<td>Ereignissknot für Buchungsereignisse für Major Donor</td>
<td></td>
</tr>
<tr>
<td>MD-MerkmalKonto</td>
<td>Merkmale, Konten und Nachlass (ja/nein) für Major Donor (Merkmal1,Konto1,Nachlass; Merkmal2,Konto2,Nachlass;...)</td>
<td></td>
</tr>
<tr>
<td>MD-MF-default</td>
<td>Default Management Fee (Prozent Projektland; Prozent Schweiz)</td>
<td>8.5;4</td>
</tr>
<tr>
<td>ohneMWSTDefault</td>
<td>Vorschlag: Personen ohne MWST (MerkmalID1,MerkmalID2,...)</td>
<td></td>
</tr>
<tr>
<td>TestAdressFormaten</td>
<td>Adress-Formate (Breite1:Höhe1:mit/ohneFunktion1, Breite2:Höhe2,mit/ohneFunktion2...)</td>
<td>30:6:ohneFunktion</td>
</tr>
<tr>
<td>BriefSchreiben</td>
<td>Adress-Format für die Funktion Brief-Schreiben (Breite:Höhe:mit/ohneFunktion1)</td>
<td>30:6:mitFunktion</td>
</tr>
<tr>
<td>OEVorschlag</td>
<td>OE-Vorschlag bei Personenerfassung, bei allen OE (*) oder nur bei den aufgeführten</td>
<td></td>
</tr>
<tr>
<td>MDRelManager</td>
<td>Beziehung für MD Relationship Manager</td>
<td></td>
</tr>
<tr>
<td>MDOrgEinheit</td>
<td>Organisatorische Einheit für Major Donor</td>
<td></td>
</tr>
<tr>
<td>ZusFaktExportFormat</td>
<td>Default Export-Format für Zusage-Fakturierung</td>
<td></td>
</tr>
<tr>
<td>TmAlnovis-Schnittstelle</td>
<td>TM Alnovis Schnittstelle, Format: TM-Verzeichnis</td>
<td></td>
</tr>
<tr>
<td>TelMarketingAktion</td>
<td>Telefon-Marketing Aktionen (xml)</td>
<td></td>
</tr>
<tr>
<td>TelMarketingParam</td>
<td>Telefon-Marketing Parametrisierung (xml)</td>
<td></td>
</tr>
<tr>
<td>VeranstGruppeDoku</td>
<td>Veranstaltungen: Dokument nur für Gruppenvorstand erstellen (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>DOAdresseAnzalZeilen</td>
<td>DO XmlSchema: Anzahl Zeilen pro Adresse (4-6)</td>
<td>6</td>
</tr>
<tr>
<td>ViewCustomConfig</td>
<td>Personalisiertes UI, Konfiguration</td>
<td></td>
</tr>
<tr>
<td>beskopf.kopfnum</td>
<td>Erste freie Bestellkopfnummer</td>
<td></td>
</tr>
<tr>
<td>adrAktDienste</td>
<td>Liste von Adressaktuallisierungsdiensten (AO,AWS,CRIF,MM,MS)</td>
<td></td>
</tr>
<tr>
<td>adrAktEreig</td>
<td>Ereignisse für Adressaktuallisierung</td>
<td></td>
</tr>
<tr>
<td>AktionenZugesagt</td>
<td>Aktionen mit Sammelnummer für Zahlungen ([Aktion],[Status];...)</td>
<td></td>
</tr>
<tr>
<td>projektFinanzierung_Version</td>
<td>Projekt-Finanzierung Version (1 - Standard, 2 - vereinfachte Version)</td>
<td>1</td>
</tr>
<tr>
<td>EF_AdressatEinzahlMehrzahl</td>
<td>Exportfeld AdressatEinzahlMehrzahl (mögliche Parameter anredecode, gescode)</td>
<td><code v-pre>&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; ?&gt; &lt;parameter&gt; &lt;typ anredecode=&quot;&quot; gescode=&quot;f&quot;&gt;E&lt;/typ&gt; &lt;typ anredecode=&quot;&quot; gescode=&quot;m&quot;&gt;E&lt;/typ&gt; &lt;typ&gt;M&lt;/typ&gt; &lt;/parameter&gt;</code></td>
</tr>
<tr>
<td>PostDatamatrixRetour</td>
<td>Post Datamatrix Retouren, Refüse Kategorien</td>
<td><code v-pre>&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; ?&gt; &lt;parameter&gt; &lt;kat grundcode=&quot;1&quot;&gt;X&lt;/kat&gt; &lt;!-- Retourengrund unbekannt --&gt; &lt;kat grundcode=&quot;10&quot;&gt;U&lt;/kat&gt; &lt;!-- weggezogen (blau) --&gt; &lt;kat grundcode=&quot;20&quot;&gt;U&lt;/kat&gt; &lt;!-- Empf. konnte nicht ermittelt werden (orange) --&gt; &lt;kat grundcode=&quot;40&quot;&gt;G&lt;/kat&gt; &lt;!-- gestorben --&gt; &lt;kat grundcode=&quot;50&quot;&gt;G&lt;/kat&gt; &lt;!-- Firma erloschen --&gt; &lt;kat grundcode=&quot;60&quot;&gt;X&lt;/kat&gt; &lt;!-- Briefkasten nicht geleert --&gt; &lt;kat grundcode=&quot;70&quot;&gt;X&lt;/kat&gt; &lt;!-- Rueckgabe durch empfaenger (rot) --&gt; &lt;kat grundcode=&quot;80&quot; artcode=&quot;30&quot;&gt;V&lt;/kat&gt; &lt;!-- nicht angenommen, Adresse korrekt (gelb) --&gt; &lt;kat artcode=&quot;10&quot;&gt;U&lt;/kat&gt; &lt;!-- Adresse ungueltig --&gt; &lt;kat artcode=&quot;30&quot;&gt;X&lt;/kat&gt; &lt;!-- Annahme verweigert --&gt; &lt;kat artcode=&quot;40&quot;&gt;X&lt;/kat&gt; &lt;!-- Retourenart unbekannt --&gt; &lt;kat&gt;&lt;/kat&gt; &lt;/parameter&gt;</code></td>
</tr>
<tr>
<td>AutoErfassungOrgZuKontakt</td>
<td>automatische Erfassung der Organisation (ja/nein)</td>
<td>nein</td>
</tr>
<tr>
<td>EreignisFilter</td>
<td>Ereignisfilter - Initial Werte</td>
<td><code v-pre>&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; ?&gt; &lt;ttEreignisFilter&gt; &lt;bezug_eigene&gt;true&lt;/bezug_eigene&gt; &lt;bezug_fremdadresse&gt;true&lt;/bezug_fremdadresse&gt; &lt;bezug_haushalt&gt;true&lt;/bezug_haushalt&gt; &lt;bezug_beschenkte&gt;true&lt;/bezug_beschenkte&gt; &lt;bezug_drittzahler&gt;true&lt;/bezug_drittzahler&gt; &lt;typ_initial&gt;true&lt;/typ_initial&gt; &lt;typ_response&gt;true&lt;/typ_response&gt; &lt;typ_refusee&gt;true&lt;/typ_refusee&gt; &lt;typ_aktion&gt;true&lt;/typ_aktion&gt; &lt;typ_sonstige&gt;true&lt;/typ_sonstige&gt; &lt;kanal_ohne&gt;true&lt;/kanal_ohne&gt; &lt;kanal_post&gt;true&lt;/kanal_post&gt; &lt;kanal_email&gt;true&lt;/kanal_email&gt; &lt;kanal_sonstige&gt;true&lt;/kanal_sonstige&gt; &lt;gruppieren&gt;true&lt;/gruppieren&gt; &lt;/ttEreignisFilter&gt; </code></td>
</tr>
<tr>
<td>EreigFilterPersonal</td>
<td>Individueller Ereignisfilter</td>
<td><code v-pre>&lt;?xml version=&quot;1.0&quot; encoding=&quot;UTF-8&quot; ?&gt; &lt;ttEreigFilterPersonal&gt; &lt;/ttEreigFilterPersonal&gt;</code></td>
</tr>
<tr>
<td>HHVerdankungAbfragen</td>
<td>Verdankung mit Haushaltanrede wählbar beim manuellen Buchen</td>
<td>ja</td>
</tr>
<tr>
<td>AggBuchKonten</td>
<td>Aggregierte Buchungen Konten</td>
<td></td>
</tr>
<tr>
<td>GDPR</td>
<td>DSGVO Parameter, Format: Personen#Sperrereignis#Anonymereignis (Personen:AnonymPersonNr.; AnonymFremdNr.), (Sperrereignis:EreignisNr.; EreignisPosNr.;Typ;Kategorie), (Anonymereignis:EreignisNr.; EreignisPosNr.;Typ;Kategorie)</td>
<td></td>
</tr>
<tr>
<td>SixBankenstamm</td>
<td>SIX Bankenstamm</td>
<td>https://api.six-group.com/api/epcd/bankmaster/v2/public/downloads/bcbankenstamm</td>
</tr>
<tr>
<td>FdsPostZahlParam</td>
<td>FDS Post Zahlungen - Parametrisierungswerte</td>
<td></td>
</tr>
<tr>
<td>ArtikelListe2Bestellart</td>
<td>Artikelliste für Konkretes Bestellart in Xml Format</td>
<td></td>
</tr>
<tr>
<td>BuchImp</td>
<td>Buchungen einlesen Parametrisierung, Format: FieldValutaDatum (BookgDt)</td>
<td>BookgDt</td>
</tr>
<tr>
<td>Personalausbildung</td>
<td>Personalausbildung</td>
<td></td>
</tr>
</tbody>
</table>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Systemparameter</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>P-ID</dt>
<dd>Kennzeichnung des Systemparameters</dd>
<dt>Bezeichnung</dt>
<dd>Bedeutung des Systemparameters, freies Textfeld, 50 Zeichen</dd>
<dt>File-Name</dt>
<dd>Nicht benutzt</dd>
<dt>Feld-Name</dt>
<dd>Nicht benutzt</dd>
<dt>Wert</dt>
<dd>Wert(e), die durch den Systemparameter besetzt sind: z.B. bedeutet der Wert 465 beim Parameter [aufh], dass alte Aufträge nach 465 Tagen in die Historydatei kopiert werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="email-message-body" tabindex="-1"><a class="header-anchor" href="#email-message-body"><span>Email Message Body</span></a></h2>
<div class="language-html line-numbers-mode" data-highlighter="prismjs" data-ext="html"><pre v-pre><code><span class="line"><span class="token doctype"><span class="token punctuation">&lt;!</span><span class="token doctype-tag">doctype</span> <span class="token name">html</span><span class="token punctuation">></span></span> </span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>html</span><span class="token punctuation">></span></span> </span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>head</span><span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>meta</span> <span class="token attr-name">name</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>viewport<span class="token punctuation">"</span></span> <span class="token attr-name">content</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>width=device-width<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>meta</span> <span class="token attr-name">http-equiv</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>Content-Type<span class="token punctuation">"</span></span> <span class="token attr-name">content</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>text/html; charset=UTF-8<span class="token punctuation">"</span></span><span class="token punctuation">></span></span> </span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>title</span><span class="token punctuation">></span></span>Simple Transactional Email<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>title</span><span class="token punctuation">></span></span> </span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>style</span><span class="token punctuation">></span></span><span class="token style"><span class="token language-css"> <span class="token comment">/* ------------------------------------- INLINED WITH htmlemail.io/inline ------------------------------------- */</span> <span class="token comment">/* ------------------------------------- RESPONSIVE AND MOBILE FRIENDLY STYLES ------------------------------------- */</span> <span class="token atrule"><span class="token rule">@media</span> <span class="token keyword">only</span> screen <span class="token keyword">and</span> <span class="token punctuation">(</span><span class="token property">max-width</span><span class="token punctuation">:</span> 620px<span class="token punctuation">)</span></span> <span class="token punctuation">{</span> <span class="token selector">table[class=body] h1</span> <span class="token punctuation">{</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 28px <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">margin-bottom</span><span class="token punctuation">:</span> 10px <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] p, table[class=body] ul, table[class=body] ol, table[class=body] td, table[class=body] span, table[class=body] a</span> <span class="token punctuation">{</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 16px <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .wrapper, table[class=body] .article</span> <span class="token punctuation">{</span> <span class="token property">padding</span><span class="token punctuation">:</span> 10px <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .content</span> <span class="token punctuation">{</span> <span class="token property">padding</span><span class="token punctuation">:</span> 0 <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .container</span> <span class="token punctuation">{</span> <span class="token property">padding</span><span class="token punctuation">:</span> 0 <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100% <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .main</span> <span class="token punctuation">{</span> <span class="token property">border-left-width</span><span class="token punctuation">:</span> 0 <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">border-radius</span><span class="token punctuation">:</span> 0 <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">border-right-width</span><span class="token punctuation">:</span> 0 <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .btn table</span> <span class="token punctuation">{</span> <span class="token property">width</span><span class="token punctuation">:</span> 100% <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .btn a</span> <span class="token punctuation">{</span> <span class="token property">width</span><span class="token punctuation">:</span> 100% <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">table[class=body] .img-responsive</span> <span class="token punctuation">{</span> <span class="token property">height</span><span class="token punctuation">:</span> auto <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">max-width</span><span class="token punctuation">:</span> 100% <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> auto <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token punctuation">}</span> <span class="token comment">/* ------------------------------------- PRESERVE THESE STYLES IN THE HEAD ------------------------------------- */</span> <span class="token atrule"><span class="token rule">@media</span> all</span> <span class="token punctuation">{</span> <span class="token selector">.ExternalClass</span> <span class="token punctuation">{</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">.ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div</span> <span class="token punctuation">{</span> <span class="token property">line-height</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">.apple-link a</span> <span class="token punctuation">{</span> <span class="token property">color</span><span class="token punctuation">:</span> inherit <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">font-family</span><span class="token punctuation">:</span> inherit <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> inherit <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">font-weight</span><span class="token punctuation">:</span> inherit <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">line-height</span><span class="token punctuation">:</span> inherit <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">text-decoration</span><span class="token punctuation">:</span> none <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">.btn-primary table td:hover</span> <span class="token punctuation">{</span> <span class="token property">background-color</span><span class="token punctuation">:</span> #34495e <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token selector">.btn-primary a:hover</span> <span class="token punctuation">{</span> <span class="token property">background-color</span><span class="token punctuation">:</span> #34495e <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token property">border-color</span><span class="token punctuation">:</span> #34495e <span class="token important">!important</span><span class="token punctuation">;</span> <span class="token punctuation">}</span> <span class="token punctuation">}</span> </span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>style</span><span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>head</span><span class="token punctuation">></span></span></span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>body</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">background-color</span><span class="token punctuation">:</span> #f6f6f6<span class="token punctuation">;</span> <span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">-webkit-font-smoothing</span><span class="token punctuation">:</span> antialiased<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">line-height</span><span class="token punctuation">:</span> 1.4<span class="token punctuation">;</span> <span class="token property">margin</span><span class="token punctuation">:</span> 0<span class="token punctuation">;</span> <span class="token property">padding</span><span class="token punctuation">:</span> 0<span class="token punctuation">;</span> <span class="token property">-ms-text-size-adjust</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span> <span class="token property">-webkit-text-size-adjust</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>table</span> <span class="token attr-name">border</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellpadding</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellspacing</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>body<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">border-collapse</span><span class="token punctuation">:</span> separate<span class="token punctuation">;</span> <span class="token property">mso-table-lspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">mso-table-rspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span> <span class="token property">background-color</span><span class="token punctuation">:</span> #f6f6f6<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span><span class="token entity named-entity" title="&nbsp;">&amp;nbsp;</span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>container<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span> <span class="token property">display</span><span class="token punctuation">:</span> block<span class="token punctuation">;</span> <span class="token property">Margin</span><span class="token punctuation">:</span> 0 auto<span class="token punctuation">;</span> <span class="token property">max-width</span><span class="token punctuation">:</span> 580px<span class="token punctuation">;</span> <span class="token property">padding</span><span class="token punctuation">:</span> 10px<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 580px<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>content<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">box-sizing</span><span class="token punctuation">:</span> border-box<span class="token punctuation">;</span> <span class="token property">display</span><span class="token punctuation">:</span> block<span class="token punctuation">;</span> <span class="token property">Margin</span><span class="token punctuation">:</span> 0 auto<span class="token punctuation">;</span> <span class="token property">max-width</span><span class="token punctuation">:</span> 580px<span class="token punctuation">;</span> <span class="token property">padding</span><span class="token punctuation">:</span> 10px<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token comment">&lt;!-- START CENTERED WHITE CONTAINER --></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>table</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>main<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">border-collapse</span><span class="token punctuation">:</span> separate<span class="token punctuation">;</span> <span class="token property">mso-table-lspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">mso-table-rspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span> <span class="token property">background</span><span class="token punctuation">:</span> #ffffff<span class="token punctuation">;</span> <span class="token property">border-radius</span><span class="token punctuation">:</span> 3px<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token comment">&lt;!-- START MAIN CONTENT AREA --></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>wrapper<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span> <span class="token property">box-sizing</span><span class="token punctuation">:</span> border-box<span class="token punctuation">;</span> <span class="token property">padding</span><span class="token punctuation">:</span> 20px<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>table</span> <span class="token attr-name">border</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellpadding</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellspacing</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">border-collapse</span><span class="token punctuation">:</span> separate<span class="token punctuation">;</span> <span class="token property">mso-table-lspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">mso-table-rspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token comment">&lt;!--MAIN-CONTENT-REPLACE--></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>table</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>tr</span><span class="token punctuation">></span></span> <span class="token comment">&lt;!-- END MAIN CONTENT AREA --></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>table</span><span class="token punctuation">></span></span> <span class="token comment">&lt;!-- START FOOTER --></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>footer<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">clear</span><span class="token punctuation">:</span> both<span class="token punctuation">;</span> <span class="token property">Margin-top</span><span class="token punctuation">:</span> 10px<span class="token punctuation">;</span> <span class="token property">text-align</span><span class="token punctuation">:</span> center<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>table</span> <span class="token attr-name">border</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellpadding</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token attr-name">cellspacing</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>0<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">border-collapse</span><span class="token punctuation">:</span> separate<span class="token punctuation">;</span> <span class="token property">mso-table-lspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">mso-table-rspace</span><span class="token punctuation">:</span> 0pt<span class="token punctuation">;</span> <span class="token property">width</span><span class="token punctuation">:</span> 100%<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>content-block powered-by<span class="token punctuation">"</span></span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span> <span class="token property">padding-bottom</span><span class="token punctuation">:</span> 10px<span class="token punctuation">;</span> <span class="token property">padding-top</span><span class="token punctuation">:</span> 10px<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 12px<span class="token punctuation">;</span> <span class="token property">color</span><span class="token punctuation">:</span> #999999<span class="token punctuation">;</span> <span class="token property">text-align</span><span class="token punctuation">:</span> center<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span> <span class="token comment">&lt;!--FOOTER-CONTENT-REPLACE--></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>table</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span> <span class="token comment">&lt;!-- END FOOTER --></span> <span class="token comment">&lt;!-- END CENTERED WHITE CONTAINER --></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>td</span> <span class="token special-attr"><span class="token attr-name">style</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span><span class="token value css language-css"><span class="token property">font-family</span><span class="token punctuation">:</span> sans-serif<span class="token punctuation">;</span> <span class="token property">font-size</span><span class="token punctuation">:</span> 14px<span class="token punctuation">;</span> <span class="token property">vertical-align</span><span class="token punctuation">:</span> top<span class="token punctuation">;</span></span><span class="token punctuation">"</span></span></span><span class="token punctuation">></span></span><span class="token entity named-entity" title="&nbsp;">&amp;nbsp;</span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>td</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>tr</span><span class="token punctuation">></span></span> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>table</span><span class="token punctuation">></span></span></span>
<span class="line">   <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>body</span><span class="token punctuation">></span></span> </span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>html</span><span class="token punctuation">></span></span> </span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html" title="Kapitel 7. Administration">IT</RouteLink></p>
</div></template>


